import { useAuth } from '@/lib'
import { roleEnum } from '@jobilla/nexus-sdk'

export const useIsJobillan = () => {
	const { role } = useAuth()
	return role === roleEnum.jobillan
}
